module.exports = __webpack_public_path__ + "img/early-release.81abc16d.png";